<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>{{ titulo }}</strong>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model="fechaDesde" 
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model="fechaHasta" 
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="!comisionesInternas"
              label="Vendedor"
              label-for="vendedor"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarVendedor">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !vendedor,
                                  'fa fa-remove': vendedor  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="vendedor"
                  :value="vendedorNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !cliente,
                                  'fa fa-remove': cliente  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchVendedorModal"
        title="Seleccionar Vendedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-vendedor
        @vendedorSeleccionado="vendedorSeleccionado">
      </app-search-vendedor>  
    </b-modal>

    <b-modal ref="searchClienteModal"
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchVendedor from '../vendedores/SearchList.vue';
import SearchCliente from '../clientes/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'VendedoresComisionesRpt',
  components: {
    appSearchVendedor: SearchVendedor,
    appSearchCliente: SearchCliente,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal
  ],
  props: {
    comisionesInternas: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      vendedor: null,
      cliente: null,

      labelCols: 2,
    }
  },
  computed: {
    vendedorNombre() {
      return this.vendedor? this.vendedor.nombre.trim() : '';
    },
    clienteNombre() {
      return this.cliente? this.cliente.nombre.trim() : '';
    },
    titulo() {
      if (this.comisionesInternas) {
        return 'Resumen de Comisiones Internas';
      }

      return 'Resumen de Comisiones';
    }
  },
  created() {
  },  
  methods: {
    inicializar() {
      this.fechaDesde = moment(new Date()).format('YYYY-MM-DD');
      this.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
      this.vendedor = null;
      this.cliente = null;
    },
    validate() {
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let vendedorId = 0;
      if (this.vendedor) {
        vendedorId = this.vendedor.id;
      }

      let clienteId = 0;
      if (this.cliente) {
        clienteId = this.cliente.id;
      }

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        vendedorId,
        clienteId,
        comisionesInternas: this.comisionesInternas
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('vendedores/getResumenPresupuestos', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rpt = this.$store.getters['vendedores/rpt'];

            if (rpt) {
              if (rpt.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let title= 'Resumen de Comisiones';
              let fileName = 'vendedores-comisiones';

              if (this.comisionesInternas) {
                title= 'Resumen de Comisiones Internas';
                fileName = 'comisiones-internas';
              }

              let format = [
                { titulo: 'Nro.Presupuesto', nombre: 'presupuestoNumero', formato: '' },
                { titulo: 'Fecha de Registro', nombre: 'fechaRegistro', formato: 'fecha' },
                { titulo: 'Fecha de Confirmación', nombre: 'fechaConfirmacion', formato: 'fecha' },
                { titulo: 'Fecha de Cierre', nombre: 'fechaCierre', formato: 'fecha' },
                { titulo: 'Cliente', nombre: 'cliente', formato: '' },
                { titulo: 'Accion', nombre: 'accion', formato: '' },
                { titulo: 'Total Presupuesto', nombre: 'montoPresupuesto', formato: '' },
                { titulo: 'Pje.Rentabilidad', nombre: 'pjeRentabilidad', formato: '' },
                { titulo: 'Rentabilidad', nombre: 'rentabilidad', formato: '' }
              ];

              if (!this.comisionesInternas) {
                format.push(
                  { titulo: 'Vendedor', nombre: 'vendedorNombre', formato: '' }
                );
              }

              format.push(
                { titulo: 'Total Comisionable', nombre: 'montoPresupuestoComisionable', formato: '' },
                { titulo: 'Tipo Comisión', nombre: 'tipoComisionDescripcion', formato: '' },
                { titulo: 'Pje.Comisión', nombre: 'pjeComision', formato: 'numero' },
                { titulo: 'Facturado', nombre: 'montoVenta', formato: '' },
                { titulo: 'Cobrado', nombre: 'montoCobros', formato: '' },
                { titulo: 'Comisión', nombre: 'totalComision', formato: '' },
                { titulo: 'Compras', nombre: 'totalCompras', formato: '' }
              );

              if (!this.comisionesInternas) {
                format.push(
                  { titulo: 'Saldos Cancelados', nombre: 'totalCancelaciones', formato: '' }
                );
                // format.push(
                //   { titulo: 'Saldo Cancelado', nombre: 'saldoCancelado', formato: 'bool' },
                //   { titulo: 'Cancelación Saldo', nombre: 'fechaCancelacionSaldo', formato: 'fecha' },
                //   { titulo: 'Usuario', nombre: 'usuarioCancelacionSaldo', formato: '' }
                // );
              }

              this.exportXLS(title, fileName, rpt, format);

            } else {
              this.showModalMsj('No hay datos para exportar', null, null, 'light')
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    seleccionarVendedor() {
      if (this.vendedor) {
        this.vendedor = null;
      } else {
        this.$refs.searchVendedorModal.show();
      }
    },
    vendedorSeleccionado(item) {
      this.vendedor = item;
      this.$refs.searchVendedorModal.hide();
    },
    seleccionarCliente() {
      if (this.cliente) {
        this.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(item) {
      this.cliente = item;
      this.$refs.searchClienteModal.hide();
    },
  },
  watch: {
    'comisionesInternas'() {
      this.inicializar();
    }
  }  
}
</script>

<style>
</style>
